import userList from '@/api/sample/mock/woodTemplate1.json'
import request from '@/utils/request'
import { isUseAPI } from '@/utils/check'

export function getUserAuth(retrieveData) {
  if (isUseAPI()) {
    // 차후 변경될 Restful 형식에 따라 수정해야 함
    return request({
      url:
        '/hiway/authusers/apps/' + retrieveData.app_id + '/users/' + retrieveData.user_id,
      method: 'get',
      meta: { apiVersion: '2.0.0' }
    })
  }
  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(userList)
  })
}
export function getUserGroups(retrieveData) {
  console.log(
    'retrieveData.app_id :',
    retrieveData.app_id,
    'retrieveData.user_id',
    retrieveData.user_id
  )
  if (isUseAPI()) {
    // 차후 변경될 Restful 형식에 따라 수정해야 함
    return request({
      url:
        '/hiway/authgroups/apps/' + retrieveData.app_id + '/users/' + retrieveData.user_id,
      method: 'get',
      meta: { apiVersion: '2.0.0' }
    })
  }
}
export function getSystemAuthGroups(retrieveData) {
  console.log(
    retrieveData.app_id
  )
  if (isUseAPI()) {
    // 차후 변경될 Restful 형식에 따라 수정해야 함
    return request({
      url:
        '/hiway/authgroups/apps/' + retrieveData.app_id,
      method: 'get',
      meta: { apiVersion: '2.0.0' }
    })
  }
  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    // var success = authGroupMockupData
    // if (retrieveData) {
    //   // 선택된 usergroup_id 가 있을 경우 해당 id와 같은 usergroup_id 를 가진 menugorup만 조회
    //   success = authGroupMockupData.filter(authGroup => {
    //     return authGroup.usergroup_id === retrieveData.usergroup_id
    //   })
    // }
    resolve(resolve)
  })
}
export function saveSampleData() {
  return request({
    url: '/save',
    method: 'post'
  })
}

export function getUserAuthSpecificMenu(retrieveData) {
  if (isUseAPI()) {
    // 차후 변경될 Restful 형식에 따라 수정해야 함
    return request({
      url:
        '/hiway/authusers/apps/' + retrieveData.app_id + '/menus/' + retrieveData.menu_id,
      method: 'get',
      meta: { apiVersion: '2.0.0' }
    })
  }
  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
  })
}
